import React from "react";
import { Box } from "@chakra-ui/react";

function index({ children }) {
  return (
    <Box
      w={{ base: "100%", md: "32%" }}
      height="250px"
      bg="radial-gradient(50% 50% at 50% 50%, #213869 13.54%, #110A2E 66.15%)"
      border="3px solid #7A20AB"
      borderRadius="15px"
      color="#ffffff"
      my={3}
    >
      {children}
    </Box>
  );
}

export default index;
